module.exports = ['$http', '$q', function($http, $q) {

	var baseUrl = '/lookup/';
	var homepageDataServiceID = 'homepage/prod-authoring-homepage-data';

	/**
	* Returns a promise to the service's URL String 
	* @param {String} id, a service id (from http://dx-marathon-3-slave6.rtp.raleigh.ibm.com:32001/ui/#/bandd1/services)
	* @return {Promise}
	*/
	function getServiceUrlById(id) {
		return $http.get(baseUrl + id).then(
			(res) => res.data,
			(res) => $q.reject('Error retrieving "' + id + '" service url: ' + res.status + ' :: ' + res.data + '')
		);
	}

	/**
	* Returns a promise to the homepage data service's URL String 
	* @return {Promise}
	*/
	function getHomepageDataUrl() {
		return this.getServiceUrlById(homepageDataServiceID);
	}


	// return public API for the REST factory
    return {
		getServiceUrlById: getServiceUrlById,
		getHomepageDataUrl: getHomepageDataUrl
    };
}];



// WEBPACK FOOTER //
// ./app/common/services/service-lookup.factory.js